import axios from 'axios'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: '/api',
  timeout: 15000
})

// Request interceptor
service.interceptors.request.use(
  config => {
    const token = store.getters['user/token']
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// Response interceptor
let isLoggingOut = false

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code && res.code !== 200) {
      // Token expired — only logout once to avoid duplicate dispatches
      // skipLogout: true 允许调用方自行处理 401（如 fetchKycStatus），不触发全局登出
      // 本地无 token 时（未登录状态，如登录/注册页）不触发登出跳转，避免打断用户输入
      if (res.code === 401 && !isLoggingOut && !response.config.skipLogout && store.getters['user/token']) {
        isLoggingOut = true
        store.dispatch('user/logout').finally(() => {
          // Reset flag after navigation completes
          setTimeout(() => { isLoggingOut = false }, 1000)
        })
        router.push('/login')
      }
      return Promise.reject(new Error(res.msg || '请求失败，请稍后重试'))
    }
    return res
  },
  error => {
    console.error('请求错误:', error)
    // HTTP 401 状态码（后端一般返回 HTTP 200 + code:401，但也可能直接返回 HTTP 401）
    // 本地无 token 时（未登录状态）不触发登出跳转，避免打断登录/注册页用户输入
    if (error.response && error.response.status === 401 && !isLoggingOut && !error.config?.skipLogout && store.getters['user/token']) {
      isLoggingOut = true
      store.dispatch('user/logout').finally(() => {
        setTimeout(() => { isLoggingOut = false }, 1000)
      })
      router.push('/login')
      return Promise.reject(new Error('认证令牌已失效'))
    }
    // 网络错误或后端不可用时，抛出更友好的错误信息
    const msg = error.response
      ? `请求失败 (${error.response.status})`
      : '网络连接失败，请检查网络'
    return Promise.reject(new Error(msg))
  }
)

export default service
